import React, { type FC } from 'react';
import { NotificationBanner } from '@wix/wix-base-ui';
import { useTranslation } from 'react-i18next';
import * as util from '#packages/util';

import { biLogger } from '#packages/util';
import { topBarMenuItemHover } from '@wix/bi-logger-editor/v2';

export enum MigrationBannerType {
  PAGE = 'page',
  SITE = 'site',
}

interface SectionsMigrationBannerComponentProps {
  type: MigrationBannerType;
  text: string;
  link: string;
  onLinkClick: () => void;
}

const SectionsMigrationBannerComponent: FC<
  SectionsMigrationBannerComponentProps
> = ({ type, text, link, onLinkClick }) => {
  const [translate] = useTranslation();

  const reportOnHover = () => {
    if (type === MigrationBannerType.SITE) {
      biLogger.report(
        topBarMenuItemHover({
          menu_item_name: 'update_editor_banner',
        }),
      );
    }
  };

  return (
    <div onMouseEnter={() => reportOnHover()}>
      <NotificationBanner
        dataHook="top-bar-sections-migration-banner"
        shouldTranslate={false}
        skin="warning"
        type="floating"
        text={translate(text)}
        link={{
          label: translate(link),
          onClick: onLinkClick,
        }}
      />
    </div>
  );
};

export const SectionsMigrationBanner = util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  undefined,
  undefined,
)(SectionsMigrationBannerComponent);
